// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/maisy-light-background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */
:root {
  --primary-blue: #1a237e;
  --secondary-blue: #303f9f;
  --accent-yellow: #ffc107;
  --call-green: #4CAF50;
  --end-call-red: #f44336;
  --text-white: #ffffff;
  --text-gray: #b0bec5;
  --background-dark: #0a0a0a;
  --phone-bg: linear-gradient(135deg, #1a237e 0%, #303f9f 100%);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  height: 100%;
  min-height: 100vh;
  min-height: -webkit-fill-available;
  text-size-adjust: 100%;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: var(--background-dark);
  color: var(--text-white);
  min-height: 100vh;
  min-height: -webkit-fill-available;
}

.app-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  padding: 0;
}

.phone-mockup {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 30px;
  width: 400px;
  max-width: 100vw;
  height: 750px;
  max-height: 100vh;
  padding: 36px 28px 0 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  gap: 1.2rem;
}

/* Language Dropdown Styling */
.language-dropdown-container {
  margin-left: 16px;
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
}

.language-dropdown {
  background: transparent;
  color: var(--text-white);
  font-weight: 600;
  font-size: 16px;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 8px 8px 8px 8px; /* Reduce right padding for closer arrow */
  border-radius: 6px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  transition: background 0.2s;
  letter-spacing: 0.2px;
  width: auto;
  min-width: unset;
}

.language-dropdown:hover {
  background: rgba(255, 255, 255, 0.1); /* Subtle hover effect */
}

.language-dropdown:focus {
  background: rgba(255, 255, 255, 0.15); /* Slightly more visible focus */
  box-shadow: none; /* Remove default focus shadow */
}

.language-dropdown option {
  color: #000000; /* Black text for dropdown options */
  font-weight: 500;
  background: #ffffff; /* White background for options */
  font-size: 16px;
}

.language-dropdown-arrow {
  position: absolute;
  right: 2px; /* Move arrow very close to text */
  pointer-events: none;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  height: 100%;
}

.language-dropdown-arrow svg {
  display: block;
}

.language-dropdown-arrow svg path {
  stroke: var(--text-white); /* White arrow to match text */
}

.phone-mockup.light-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.phone-mockup::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);
  pointer-events: none;
}

/* Logo Section */
.logo-container {
  text-align: center;
  margin-bottom: 8px;
}

.logo {
  width: 120px;
  height: auto;
  margin-bottom: 10px;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
}

.logo-subtitle {
  font-size: 18px;
  color: var(--text-gray);
  letter-spacing: 1px;
  font-weight: bold;
}

.excide-user-input {
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.08);
  color: var(--text-white);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.3px;
  outline: none;
  transition: background 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.excide-user-input::placeholder {
  color: rgba(255, 255, 255, 0.6);
  text-transform: capitalize;
}

.excide-user-input:hover,
.excide-user-input:focus {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.4);
  box-shadow: 0 12px 32px rgba(26, 35, 126, 0.28);
}

.excide-user-input:focus {
  box-shadow: 0 14px 36px rgba(26, 35, 126, 0.32);
}

/* Toggle */
.toggle-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 8px;
  gap: 6px; /* Reduce gap for tighter alignment */
}

.toggle-label {
  font-size: 18px;
  margin: 0 4px;
  font-weight: 600;
  letter-spacing: 0.5px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  height: 28px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
  margin: 0 2px;
  vertical-align: middle;
}

.switch input { display: none; }

.switch input:disabled + .slider {
  opacity: 0.6;
  cursor: not-allowed;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 28px;
  height: 28px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #1a73e8;
}

input:checked + .slider:before {
  transform: translateX(20px);
}

.realtime-control {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 4px;
}

.realtime-toggle-label {
  font-size: 14px;
  margin: 0 2px;
}

.realtime-switch {
  width: 36px;
  height: 22px;
}

.realtime-switch .slider {
  height: 24px;
}

.realtime-switch .slider:before {
  height: 18px;
  width: 18px;
}

.realtime-switch input:checked + .slider:before {
  transform: translateX(14px);
}

/* Call Section */
.call-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
  justify-content: center;
  width: 100%;
  min-height: 180px;
}

.call-button-container {
  position: relative;
  margin-bottom: 18px;
}

.call-button {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  background: transparent;
  padding: 0;
}

.call-button:hover {
  transform: scale(1.05);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);
}

.call-button:active {
  transform: scale(0.95);
}

.call-button:disabled {
  cursor: not-allowed;
  opacity: 0.8;
}

.call-icon {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.start-call .call-icon {
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  box-shadow: inset 0 2px 4px rgba(255, 255, 255, 0.2);
}

.end-call .call-icon {
  background: linear-gradient(135deg, #f44336 0%, #d32f2f 100%);
  box-shadow: inset 0 2px 4px rgba(255, 255, 255, 0.2);
}

.call-icon svg {
  width: 38px;
  height: 38px;
  color: white;
}

/* Loading Animation */
.loading-ring {
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  border: 3px solid transparent;
  border-top: 3px solid var(--accent-yellow);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.button-label {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-white);
  letter-spacing: 1px;
  text-align: center;
}

/* Speaking Indicator */
.speaking-indicator {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
  font-size: 15px;
  color: var(--call-green);
  font-weight: 500;
}

.pulse-dot {
  width: 8px;
  height: 8px;
  background: var(--call-green);
  border-radius: 50%;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.3); opacity: 0.6; }
  100% { transform: scale(1); opacity: 1; }
}

/* Chat Placeholder */
.chat-placeholder {
  min-height: 120px;
  width: 100%;
}

/* Chat Container */
.chat-container {
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 16px;
  padding: 12px 16px;
  max-height: 140px;
  overflow: hidden;
  margin-top: 8px;
}

.chat-header {
  font-size: 15px;
  font-weight: 600;
  color: var(--accent-yellow);
  margin-bottom: 6px;
}

.chat-messages {
  max-height: 100px;
  overflow-y: auto;
  font-size: 13px;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}

.chat-messages::-webkit-scrollbar {
  width: 4px;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.chat-message {
  margin-bottom: 8px;
  font-size: 13px;
  line-height: 1.4;
}

.sender {
  font-weight: 600;
  color: var(--accent-yellow);
}

.no-messages {
  text-align: center;
  color: var(--text-gray);
  font-style: italic;
  font-size: 12px;
}

/* Bot Container - Default (Desktop/Tablet) */
.bot-container {
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  padding: 0 20px 24px;
  margin-bottom: 0;
  position: relative;
}

.bot-image {
  width: clamp(120px, 45%, 180px);
  max-width: 180px;
  height: auto;
  border-radius: 50%;
  filter: drop-shadow(0 6px 18px rgba(0, 0, 0, 0.35));
  transition: transform 0.3s ease;
}

.bot-image:hover {
  transform: scale(1.05);
}

/* TABLET/LAPTOP: 701px–1200px */
@media (min-width: 701px) and (max-width: 1200px) {
  .phone-mockup {
    width: 90vw;
    height: 90vh;
    padding: 32px 18px 0 18px;
  }
  .bot-container {
    margin-bottom: 12px;
    padding: 0 24px 20px;
  }
  .bot-image {
    max-width: 160px;
  }
}

/* MOBILE: <=700px */
@media (max-width: 700px) {
  .app-container {
    padding: 0;
    height: 100vh;
    width: 100vw;
    min-height: 100vh;
    min-width: 100vw;
    box-sizing: border-box;
  }
  .phone-mockup {
    width: 100vw !important;
    max-width: 100vw !important;
    height: 100vh !important;
    max-height: 100vh !important;
    min-width: 100vw !important;
    min-height: 100vh !important;
    border-radius: 0 !important;
    padding: 24px 6px 0 6px;
    box-shadow: none;
    box-sizing: border-box;
    justify-content: flex-start;
    gap: 0.7rem;
  }
  .logo {
    width: 100px;
  }
  .logo-subtitle {
    font-size: 16px !important;
  }
  .toggle-label {
    font-size: 16px !important;
    margin: 0 2px !important;
    height: 22px;
  }
  .switch {
    width: 32px;
    height: 18px;
    margin: 0 1px;
  }
  .slider {
    height: 22px;
  }
  .slider:before {
    height: 16px;
    width: 16px;
    left: 3px;
    bottom: 3px;
  }
  .language-dropdown-container {
    height: 32px;
    min-width: unset;
    padding: 0 2px;
  }
  .language-dropdown {
    font-size: 15px;
    padding: 4px 6px 4px 2px; /* Minimal right padding */
    min-width: unset;
    width: auto;
  }
  .language-dropdown-arrow {
    font-size: 13px;
    right: 2px;
  }
  .call-section {
    min-height: 120px;
  }
  .call-button {
    width: 70px !important;
    height: 70px !important;
  }
  .call-icon svg {
    width: 28px !important;
    height: 28px !important;
  }
  .button-label {
    font-size: 15px !important;
  }
  .speaking-indicator {
    font-size: 15px !important;
  }
  .chat-placeholder {
    min-height: 70px;
  }
  .chat-container {
    max-height: 80px;
    padding: 8px 8px;
  }
  .chat-header {
    font-size: 15px !important;
  }
  .chat-messages {
    max-height: 50px;
    font-size: 13px !important;
  }
  .bot-container {
    justify-content: center;
    padding: 0 16px 32px !important;
    margin-bottom: 0 !important;
  }
  .bot-image {
    width: 120px !important;
  }
}

/* Additional animations for enhanced UX */
.call-button.connecting .call-icon {
  animation: buttonPulse 2s infinite;
}

@keyframes buttonPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

/* Smooth transitions for state changes */
.phone-mockup > * {
  transition: all 0.3s ease;
}

/* Glass morphism effect for modern look */
.chat-container, .avatar-circle {
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

/* iOS/iPhone-specific fixes */
html {
  height: 100%;
  min-height: 100vh;
  min-height: -webkit-fill-available;
  text-size-adjust: 100%;
}

@media (min-width: 601px) and (max-width: 1200px) {
  .bot-container {
    margin-bottom: 12px !important; /* Keep bot comfortably inside frame */
    padding: 0 24px 24px;
  }
  .bot-image {
    max-width: 170px;
  }
}

.connecting-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  width: 100%;
  z-index: 2;
}

.loader-spinner {
  width: 32px;
  height: 32px;
  border: 4px solid rgba(255,255,255,0.2);
  border-top: 4px solid var(--accent-yellow);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

.loader-text {
  color: var(--text-white);
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-align: center;
}

@media (max-width: 700px) {
  .connecting-loader {
    margin-bottom: 10px;
  }
  .loader-spinner {
    width: 22px;
    height: 22px;
    border-width: 3px;
    margin-bottom: 6px;
  }
  .loader-text {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,0BAA0B;EAC1B,6DAA6D;AAC/D;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAIlC,sBAAsB;AACxB;;AAEA;EACE,4DAA4D;EAC5D,kCAAkC;EAClC,wBAAwB;EACxB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,yDAAgD;EAChD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,eAAe;EACf,wBAAwB,EAAE,0CAA0C;EACpE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oCAAoC,EAAE,wBAAwB;AAChE;;AAEA;EACE,qCAAqC,EAAE,gCAAgC;EACvE,gBAAgB,EAAE,gCAAgC;AACpD;;AAEA;EACE,cAAc,EAAE,oCAAoC;EACpD,gBAAgB;EAChB,mBAAmB,EAAE,iCAAiC;EACtD,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU,EAAE,kCAAkC;EAC9C,oBAAoB;EACpB,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;AAC3D;;AAEA;EACE,yDAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;+FAC6F;EAC7F,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,iFAAiF;EACjF,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;;EAEE,qCAAqC;EACrC,sCAAsC;EACtC,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,QAAQ,EAAE,qCAAqC;AACjD;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,gBAAgB,aAAa,EAAE;;AAE/B;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;EACP,uBAAuB;EACvB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iDAAiD;EACjD,yCAAyC;EACzC,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,oDAAoD;AACtD;;AAEA;EACE,6DAA6D;EAC7D,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,KAAK,mBAAmB,EAAE,UAAU,EAAE;EACtC,MAAM,qBAAqB,EAAE,YAAY,EAAE;EAC3C,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC1C;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mDAAmD;EACnD,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,UAAU;IACV,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;IACtB,2BAA2B;IAC3B,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;EACb;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,eAAe;IACf,wBAAwB,EAAE,0BAA0B;IACpD,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,+BAA+B;IAC/B,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA,0CAA0C;AAC1C;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA,yCAAyC;AACzC;EACE,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA,8BAA8B;AAC9B;EACE,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAIlC,sBAAsB;AACxB;;AAEA;EACE;IACE,8BAA8B,EAAE,sCAAsC;IACtE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* App.css */\n:root {\n  --primary-blue: #1a237e;\n  --secondary-blue: #303f9f;\n  --accent-yellow: #ffc107;\n  --call-green: #4CAF50;\n  --end-call-red: #f44336;\n  --text-white: #ffffff;\n  --text-gray: #b0bec5;\n  --background-dark: #0a0a0a;\n  --phone-bg: linear-gradient(135deg, #1a237e 0%, #303f9f 100%);\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  height: 100%;\n  min-height: 100vh;\n  min-height: -webkit-fill-available;\n  -webkit-text-size-adjust: 100%;\n  -moz-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n}\n\nbody {\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  background: var(--background-dark);\n  color: var(--text-white);\n  min-height: 100vh;\n  min-height: -webkit-fill-available;\n}\n\n.app-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  width: 100vw;\n  padding: 0;\n}\n\n.phone-mockup {\n  background-image: url('./assets/background.png');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  border-radius: 30px;\n  width: 400px;\n  max-width: 100vw;\n  height: 750px;\n  max-height: 100vh;\n  padding: 36px 28px 0 28px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  position: relative;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  gap: 1.2rem;\n}\n\n/* Language Dropdown Styling */\n.language-dropdown-container {\n  margin-left: 16px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 40px;\n}\n\n.language-dropdown {\n  background: transparent;\n  color: var(--text-white);\n  font-weight: 600;\n  font-size: 16px;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  padding: 8px 8px 8px 8px; /* Reduce right padding for closer arrow */\n  border-radius: 6px;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  transition: background 0.2s;\n  letter-spacing: 0.2px;\n  width: auto;\n  min-width: unset;\n}\n\n.language-dropdown:hover {\n  background: rgba(255, 255, 255, 0.1); /* Subtle hover effect */\n}\n\n.language-dropdown:focus {\n  background: rgba(255, 255, 255, 0.15); /* Slightly more visible focus */\n  box-shadow: none; /* Remove default focus shadow */\n}\n\n.language-dropdown option {\n  color: #000000; /* Black text for dropdown options */\n  font-weight: 500;\n  background: #ffffff; /* White background for options */\n  font-size: 16px;\n}\n\n.language-dropdown-arrow {\n  position: absolute;\n  right: 2px; /* Move arrow very close to text */\n  pointer-events: none;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n\n.language-dropdown-arrow svg {\n  display: block;\n}\n\n.language-dropdown-arrow svg path {\n  stroke: var(--text-white); /* White arrow to match text */\n}\n\n.phone-mockup.light-bg {\n  background-image: url('./assets/maisy-light-background.png');\n}\n\n.phone-mockup::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),\n              radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);\n  pointer-events: none;\n}\n\n/* Logo Section */\n.logo-container {\n  text-align: center;\n  margin-bottom: 8px;\n}\n\n.logo {\n  width: 120px;\n  height: auto;\n  margin-bottom: 10px;\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));\n}\n\n.logo-subtitle {\n  font-size: 18px;\n  color: var(--text-gray);\n  letter-spacing: 1px;\n  font-weight: bold;\n}\n\n.excide-user-input {\n  width: 100%;\n  padding: 12px 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.08);\n  color: var(--text-white);\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  outline: none;\n  transition: background 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n}\n\n.excide-user-input::placeholder {\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: capitalize;\n}\n\n.excide-user-input:hover,\n.excide-user-input:focus {\n  background: rgba(255, 255, 255, 0.15);\n  border-color: rgba(255, 255, 255, 0.4);\n  box-shadow: 0 12px 32px rgba(26, 35, 126, 0.28);\n}\n\n.excide-user-input:focus {\n  box-shadow: 0 14px 36px rgba(26, 35, 126, 0.32);\n}\n\n/* Toggle */\n.toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  width: 100%;\n  margin-bottom: 8px;\n  gap: 6px; /* Reduce gap for tighter alignment */\n}\n\n.toggle-label {\n  font-size: 18px;\n  margin: 0 4px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  height: 28px;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 24px;\n  margin: 0 2px;\n  vertical-align: middle;\n}\n\n.switch input { display: none; }\n\n.switch input:disabled + .slider {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background-color: #ccc;\n  transition: .4s;\n  border-radius: 28px;\n  height: 28px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 22px;\n  width: 22px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: .4s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: #1a73e8;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(20px);\n}\n\n.realtime-control {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: 4px;\n}\n\n.realtime-toggle-label {\n  font-size: 14px;\n  margin: 0 2px;\n}\n\n.realtime-switch {\n  width: 36px;\n  height: 22px;\n}\n\n.realtime-switch .slider {\n  height: 24px;\n}\n\n.realtime-switch .slider:before {\n  height: 18px;\n  width: 18px;\n}\n\n.realtime-switch input:checked + .slider:before {\n  transform: translateX(14px);\n}\n\n/* Call Section */\n.call-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n  justify-content: center;\n  width: 100%;\n  min-height: 180px;\n}\n\n.call-button-container {\n  position: relative;\n  margin-bottom: 18px;\n}\n\n.call-button {\n  width: 90px;\n  height: 90px;\n  border-radius: 50%;\n  border: none;\n  cursor: pointer;\n  position: relative;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  background: transparent;\n  padding: 0;\n}\n\n.call-button:hover {\n  transform: scale(1.05);\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);\n}\n\n.call-button:active {\n  transform: scale(0.95);\n}\n\n.call-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n\n.call-icon {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n}\n\n.start-call .call-icon {\n  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);\n  box-shadow: inset 0 2px 4px rgba(255, 255, 255, 0.2);\n}\n\n.end-call .call-icon {\n  background: linear-gradient(135deg, #f44336 0%, #d32f2f 100%);\n  box-shadow: inset 0 2px 4px rgba(255, 255, 255, 0.2);\n}\n\n.call-icon svg {\n  width: 38px;\n  height: 38px;\n  color: white;\n}\n\n/* Loading Animation */\n.loading-ring {\n  position: absolute;\n  top: -4px;\n  left: -4px;\n  right: -4px;\n  bottom: -4px;\n  border: 3px solid transparent;\n  border-top: 3px solid var(--accent-yellow);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.button-label {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-white);\n  letter-spacing: 1px;\n  text-align: center;\n}\n\n/* Speaking Indicator */\n.speaking-indicator {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 20px;\n  font-size: 15px;\n  color: var(--call-green);\n  font-weight: 500;\n}\n\n.pulse-dot {\n  width: 8px;\n  height: 8px;\n  background: var(--call-green);\n  border-radius: 50%;\n  animation: pulse 1.5s infinite;\n}\n\n@keyframes pulse {\n  0% { transform: scale(1); opacity: 1; }\n  50% { transform: scale(1.3); opacity: 0.6; }\n  100% { transform: scale(1); opacity: 1; }\n}\n\n/* Chat Placeholder */\n.chat-placeholder {\n  min-height: 120px;\n  width: 100%;\n}\n\n/* Chat Container */\n.chat-container {\n  background: rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 16px;\n  padding: 12px 16px;\n  max-height: 140px;\n  overflow: hidden;\n  margin-top: 8px;\n}\n\n.chat-header {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--accent-yellow);\n  margin-bottom: 6px;\n}\n\n.chat-messages {\n  max-height: 100px;\n  overflow-y: auto;\n  font-size: 13px;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;\n}\n\n.chat-messages::-webkit-scrollbar {\n  width: 4px;\n}\n\n.chat-messages::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 2px;\n}\n\n.chat-message {\n  margin-bottom: 8px;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.sender {\n  font-weight: 600;\n  color: var(--accent-yellow);\n}\n\n.no-messages {\n  text-align: center;\n  color: var(--text-gray);\n  font-style: italic;\n  font-size: 12px;\n}\n\n/* Bot Container - Default (Desktop/Tablet) */\n.bot-container {\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  width: 100%;\n  padding: 0 20px 24px;\n  margin-bottom: 0;\n  position: relative;\n}\n\n.bot-image {\n  width: clamp(120px, 45%, 180px);\n  max-width: 180px;\n  height: auto;\n  border-radius: 50%;\n  filter: drop-shadow(0 6px 18px rgba(0, 0, 0, 0.35));\n  transition: transform 0.3s ease;\n}\n\n.bot-image:hover {\n  transform: scale(1.05);\n}\n\n/* TABLET/LAPTOP: 701px–1200px */\n@media (min-width: 701px) and (max-width: 1200px) {\n  .phone-mockup {\n    width: 90vw;\n    height: 90vh;\n    padding: 32px 18px 0 18px;\n  }\n  .bot-container {\n    margin-bottom: 12px;\n    padding: 0 24px 20px;\n  }\n  .bot-image {\n    max-width: 160px;\n  }\n}\n\n/* MOBILE: <=700px */\n@media (max-width: 700px) {\n  .app-container {\n    padding: 0;\n    height: 100vh;\n    width: 100vw;\n    min-height: 100vh;\n    min-width: 100vw;\n    box-sizing: border-box;\n  }\n  .phone-mockup {\n    width: 100vw !important;\n    max-width: 100vw !important;\n    height: 100vh !important;\n    max-height: 100vh !important;\n    min-width: 100vw !important;\n    min-height: 100vh !important;\n    border-radius: 0 !important;\n    padding: 24px 6px 0 6px;\n    box-shadow: none;\n    box-sizing: border-box;\n    justify-content: flex-start;\n    gap: 0.7rem;\n  }\n  .logo {\n    width: 100px;\n  }\n  .logo-subtitle {\n    font-size: 16px !important;\n  }\n  .toggle-label {\n    font-size: 16px !important;\n    margin: 0 2px !important;\n    height: 22px;\n  }\n  .switch {\n    width: 32px;\n    height: 18px;\n    margin: 0 1px;\n  }\n  .slider {\n    height: 22px;\n  }\n  .slider:before {\n    height: 16px;\n    width: 16px;\n    left: 3px;\n    bottom: 3px;\n  }\n  .language-dropdown-container {\n    height: 32px;\n    min-width: unset;\n    padding: 0 2px;\n  }\n  .language-dropdown {\n    font-size: 15px;\n    padding: 4px 6px 4px 2px; /* Minimal right padding */\n    min-width: unset;\n    width: auto;\n  }\n  .language-dropdown-arrow {\n    font-size: 13px;\n    right: 2px;\n  }\n  .call-section {\n    min-height: 120px;\n  }\n  .call-button {\n    width: 70px !important;\n    height: 70px !important;\n  }\n  .call-icon svg {\n    width: 28px !important;\n    height: 28px !important;\n  }\n  .button-label {\n    font-size: 15px !important;\n  }\n  .speaking-indicator {\n    font-size: 15px !important;\n  }\n  .chat-placeholder {\n    min-height: 70px;\n  }\n  .chat-container {\n    max-height: 80px;\n    padding: 8px 8px;\n  }\n  .chat-header {\n    font-size: 15px !important;\n  }\n  .chat-messages {\n    max-height: 50px;\n    font-size: 13px !important;\n  }\n  .bot-container {\n    justify-content: center;\n    padding: 0 16px 32px !important;\n    margin-bottom: 0 !important;\n  }\n  .bot-image {\n    width: 120px !important;\n  }\n}\n\n/* Additional animations for enhanced UX */\n.call-button.connecting .call-icon {\n  animation: buttonPulse 2s infinite;\n}\n\n@keyframes buttonPulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n}\n\n/* Smooth transitions for state changes */\n.phone-mockup > * {\n  transition: all 0.3s ease;\n}\n\n/* Glass morphism effect for modern look */\n.chat-container, .avatar-circle {\n  background: rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n/* iOS/iPhone-specific fixes */\nhtml {\n  height: 100%;\n  min-height: 100vh;\n  min-height: -webkit-fill-available;\n  -webkit-text-size-adjust: 100%;\n  -moz-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n}\n\n@media (min-width: 601px) and (max-width: 1200px) {\n  .bot-container {\n    margin-bottom: 12px !important; /* Keep bot comfortably inside frame */\n    padding: 0 24px 24px;\n  }\n  .bot-image {\n    max-width: 170px;\n  }\n}\n\n.connecting-loader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 18px;\n  width: 100%;\n  z-index: 2;\n}\n\n.loader-spinner {\n  width: 32px;\n  height: 32px;\n  border: 4px solid rgba(255,255,255,0.2);\n  border-top: 4px solid var(--accent-yellow);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 10px;\n}\n\n.loader-text {\n  color: var(--text-white);\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  text-align: center;\n}\n\n@media (max-width: 700px) {\n  .connecting-loader {\n    margin-bottom: 10px;\n  }\n  .loader-spinner {\n    width: 22px;\n    height: 22px;\n    border-width: 3px;\n    margin-bottom: 6px;\n  }\n  .loader-text {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
